import EmojiSquares from '@app-studio-web/ui/components/EmojiSquares'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import ProgressBar from '@app-studio-web/ui/components/ProgressBar'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

const PROGRESS_TIME = 1500
const TITLE = 'pages.onboarding.craftingProgress.title'

// Quiz-specific final loading step. Replicates the shared ProgressPage
// auto-advance behavior. Uses the plain PageLayout (no quiz progress header) —
// this terminal loader has its own progress bar. Being the last step,
// submitting redirects to /sign-up/company.
export default function QuizCraftingProgressPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const formRef = useRef<HTMLFormElement>(null)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (formRef.current) submit(formRef.current)
    }, PROGRESS_TIME)

    return () => clearTimeout(timeout)
  }, [submit])

  return (
    <PageLayout>
      <div className="flex grow flex-col justify-center">
        <EmojiSquares emoji="🚀" spin />

        <div className="mt-7 mb-12 space-y-3">
          <p className="text-custom-black text-center text-3xl font-bold text-balance">
            {t(TITLE)}
          </p>

          <p className="text-center text-[#AFAFAF]">
            {t('pages.onboarding.craftingProgress.subtitle')}
          </p>
        </div>

        <ProgressBar
          progressTime={PROGRESS_TIME}
          subtitle={t('pages.onboarding.craftingProgress.progressBarSubtitle')}
        />
      </div>

      <Form method="post" ref={formRef}>
        <input
          name={t(TITLE, { lng: 'en' })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />
      </Form>
    </PageLayout>
  )
}
